/**
 * @file Races.
 */

/**
 * Races functions.
 *
 * Runs js specific to the Races template.
 */
const vRaces = () => {
	import('../../components/anchor-menu/anchor-menu').then((m) => { m.default(); });
};

if (document.readyState !== 'loading') {
	vRaces();
} else {
	document.addEventListener('DOMContentLoaded', vRaces);
}
